import { useSelector } from "react-redux";
import TransactionsClient from "./TransactionsClient";
import TransactionsManager from "./TransactionsManager";
import { useEffect, useState } from "react";
import { fetchScheme } from "./FetchTransactions";

const TransactionsList = () => {
  const userInfo = useSelector((state) => state.user);
  const [scheme, setScheme] = useState([]);
  const [flag, setFlag] = useState(false);
  useEffect(() => {
    if (!flag) {
      fetchScheme().then((data) => {
        if (data) {
          setScheme(data.scheme);
          setFlag(true);
        }
      });
    }
  }, [flag]);
  return (
    <>
     {userInfo.type === 0 ? <TransactionsClient userInfo={userInfo} scheme={scheme}/> : <TransactionsManager userInfo={userInfo} scheme={scheme}/>}
    </>
   
  );
}

export default TransactionsList;

